const lang = {
    appbartitle: {
        ru: 'Заметки',
        uz: 'Eslatmalar'
    },
    appbarseacrch: {
        ru: 'Поиск...',
        uz: 'Qidirish...'
    },
    infobar: {
        ru: 'Все заметки',
        uz: 'Barcha eslatmalar'
    },
    noinfobar: {
        ru: 'Нет заметок',
        uz: 'Еslatmalar yoq'
    },
    list: {
        ru: 'Список',
        uz: 'Roʻyxat'
    },
    grid: {
        ru: 'Сетка',
        uz: 'Setka'
    },
    titlewindow: {
        ru: 'Добавить заметку',
        uz: 'Eslatma qo’shish'
    },
    titlewindowedit: {
        ru: 'Изменить заметку',
        uz: 'Elsatmani tahrirlash'
    },
    editbtn: {
        ru: 'РЕДАКТИРОВАТЬ',
        uz: 'O`ZGARTIRISH'
    },
    deledit: {
        ru: 'УДАЛИТЬ',
        uz: "O'CHIRISH"
    },
    closebtn: {
        ru: 'ОТМЕНА',
        uz: "BEKOR QILISH"
    },
    addbtn: {
        ru: 'ДОБАВИТЬ',
        uz: "QO’SHISH"
    },
    editwindowbtn: {
        ru: 'ИЗМЕНИТЬ',
        uz: "o'zgartirish"
    },
    notfound:{
        ru: 'Не найдено...',
        uz: 'Topilmadi...'
    },
    
    
}
export default lang


